export default {
  path: '/agencyContract',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'list',
      name: 'agencyContractList',
      component: () => import('@/pages/contract/agencyContract/list.vue'),
      meta: {
        keepAlive: true,
        title: '代理合同总览',
      },
    },
    {
      path: 'add',
      name: 'agencyContractAdd',
      component: () => import('@/pages/contract/agencyContract/add.vue'),
      meta: {
        keepAlive: true,
        title: '创建代理合同',
      },
    },
    {
      path: 'edit',
      name: 'agencyContractEdit',
      component: () => import('@/pages/contract/agencyContract/edit.vue'),
      meta: {
        keepAlive: true,
        title: '修改代理合同',
      },
    },
  ],
};
